import React, { Component } from 'react';
import SelectLanguage from "../../../../listing/components/SelectLanguage";
import { connect } from "react-redux"
import { isKioskMode } from "../../../selectors/ui";

class InventoryContentContainer extends Component {

    render() {
        return(
            <div className="tickets__content">
                {!this.props.isKiosk && <SelectLanguage className='select-language--checkout'/> }
                <div className={!this.props.isKiosk ? 'tickets__content__list' : ''}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
  return {
    isKiosk: isKioskMode(state),
  }
}


export default connect(mapStateToProps)(InventoryContentContainer);
